import TimelineConfiguratorTabBase from "./TimelineConfiguratorTabBase.jsx";
import { PERSISTENCE_STATE_KEYS } from "../../../other/constants/PersistenceStateKeys.jsx";
import { PLUGINS_KEYS } from "../../../other/constants/PluginKeys.jsx";
import { TIMELINE_CONG_KEYS } from "../../../other/constants/OtherKeys.jsx";
import { getScheduleInstanceFromViewManager } from "../../../other/utils/otherUtils.jsx";

export default class TimelineConfiguratorSettingsTab extends TimelineConfiguratorTabBase {
  static get $name() {
    return "TimelineConfiguratorSettingsTab";
  }

  static get type() {
    return "timelineConfiguratorSettingsTab";
  }

  get stateId() {
    return PERSISTENCE_STATE_KEYS.timelineConfiguratorEditorSettingsGridState;
  }


  static get configurable() {
    return {
      title: "Settings",
      cls: "pt-[0.5em] pl-[1em]",
      items: {
        stripeColumn: {
          type: "checkbox",
          name: TIMELINE_CONG_KEYS.stripeNonWorkingDays,
          text: "Stripe Non-Working Time Columns",
          onChange: "up.onSchedulerSettingsChange",
        },
        hideColumn: {
          type: "checkbox",
          name: TIMELINE_CONG_KEYS.hideNonWorkingDays,
          text: "Hide Non-Working Time Columns",
          onChange: "up.onSchedulerSettingsChange",
        },
        ignoreColumn: {
          type: "checkbox",
          name: TIMELINE_CONG_KEYS.skipNonWorkingDayDuringReplicating,
          text: "Ignore Non-Working Time Columns",
          onChange: "up.onSchedulerSettingsChange",
        },
        informationContainer: {
          type: 'container',
          cls: "mt-[4em] gap-[1.2em]",
          layoutStyle: {
            flexDirection: 'column',
          },
          items: [
            {
              type: 'displayField',
              cls: '!text-black dark:!text-white',
              html: "Timescale, Non-Working Time, and the setting above are part of your current view only. They won’t carry over to other views unless you save them. "
            },
            {
              type: 'displayField',
              cls: '!text-black dark:!text-white',
              html: "To preserve the view, click the view name, select “Edit View,” and choose “Save” or “Save As.”"
            },
            {
              type: 'displayField',
              cls: '!text-black dark:!text-white',
              html: "Board-wide and schedule-wide defaults that apply to every view can be reviewed or changed in Personal Settings."
            },
          ]
        }
      }
    }
  }

  loadRecord(record, context, otherParams) {
    super.loadRecord(record, context, otherParams);

    const selectedState = getScheduleInstanceFromViewManager(this.context.viewManager).features[PLUGINS_KEYS.swivuTimelineConfigurator].state;

    if (selectedState) {
      this.eachWidget((w) => {
        if (w.isCheckbox) {
          w.checked = selectedState[w.name];
        }
      });
    }
  }

  onSchedulerSettingsChange({ userAction, source, value }) {
    if (userAction) {
      getScheduleInstanceFromViewManager(this.context.viewManager).features[PLUGINS_KEYS.swivuTimelineConfigurator].swivuExecuteSettings(source.name, value);
    }
  }

  onTabChangeHandler({ activeItem }) {
    if (activeItem.type === this.type) {
      this.parent.parent.bbar.hidden = false;
    }
  }
}

TimelineConfiguratorSettingsTab.initClass();
